module.exports = "/pages/business/foodslabo/fv_points_2.png";